import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ParkingSpaces from './ParkingSpaces';
import ParkingRecords from './ParkingRecords';

const ParkingManagement: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ParkingSpaces />} />
      <Route path="spaces" element={<ParkingSpaces />} />
      <Route path="records" element={<ParkingRecords />} />
    </Routes>
  );
};

export default ParkingManagement;